/**
 * Pre-prompt del push nativo: el "¿Te avisamos?" propio que va ANTES del
 * prompt del sistema. El prompt del OS es one-shot (Android 13+ / iOS: negado,
 * sólo vuelve desde Ajustes), así que no se quema en el boot: se ofrece una
 * vez, al volver a Home después de la primera charla, cuando el user ya sabe
 * para qué sirve la app. El toggle de Perfil sigue siendo la otra puerta.
 *
 * Estado por device en localStorage (es una cortesía de UI, no un dato que el
 * backend necesite): `eligible` lo marca el debrief; `answered` lo marca
 * cualquiera de los dos botones y lo apaga para siempre en ese device.
 */

const ELIGIBLE_KEY = 'orborix.speak.push.prePromptEligible';
const ANSWERED_KEY = 'orborix.speak.push.prePromptAnswered';

function read(key: string): boolean {
  try {
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function write(key: string): void {
  try {
    window.localStorage.setItem(key, '1');
  } catch {
    // Storage bloqueado: el pre-prompt puede volver a ofrecerse; Perfil sigue andando.
  }
}

/** El user terminó una charla (montó un debrief): desde ahora se puede ofrecer. */
export function markPushPrePromptEligible(): void {
  write(ELIGIBLE_KEY);
}

/** Respondió el pre-prompt (activar o "ahora no"): no se vuelve a ofrecer. */
export function markPushPrePromptAnswered(): void {
  write(ANSWERED_KEY);
}

/** Hay que ofrecerlo: ya hubo una charla y todavía no respondió. */
export function isPushPrePromptPending(): boolean {
  return read(ELIGIBLE_KEY) && !read(ANSWERED_KEY);
}
